{
  "name": "management-console",
  "version": "1.53.22",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "check-deps": "npx npm-check-updates --target semver",
    "deploy": "ng build && ts-node --project deploy/tsconfig.json deploy/index.ts",
    "deploy-prod": "ng build -c production && ts-node --project deploy/tsconfig.json deploy/index.ts --prod"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.0.4",
    "@angular/common": "^22.0.6",
    "@angular/compiler": "^22.0.6",
    "@angular/core": "^22.0.6",
    "@angular/forms": "^22.0.6",
    "@angular/platform-browser": "^22.0.6",
    "@angular/platform-browser-dynamic": "^22.0.6",
    "@angular/router": "^22.0.6",
    "aws-amplify": "^6.18.0",
    "bahttext": "^2.4.0",
    "buffer": "^6.0.3",
    "crc": "^4.3.2",
    "devextreme": "^25.2.8",
    "devextreme-angular": "^25.2.8",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "lodash": "^4.18.1",
    "moment": "^2.30.1",
    "pdf-lib": "^1.17.1",
    "rxjs": "^6.6.7",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.0.6",
    "@angular-eslint/builder": "^22.1.0",
    "@angular-eslint/schematics": "^22.1.0",
    "@angular/cli": "^22.0.6",
    "@angular/compiler-cli": "^22.0.6",
    "@aws-sdk/client-cloudfront": "^3.1086.0",
    "@aws-sdk/client-s3": "^3.1086.0",
    "@aws-sdk/lib-storage": "^3.1086.0",
    "@eslint/js": "^10.0.1",
    "@types/file-saver": "^2.0.7",
    "@types/jasmine": "^4.6.6",
    "@types/lodash": "^4.17.24",
    "@types/mime-types": "^2.1.4",
    "@types/node": "^24.13.3",
    "angular-eslint": "^22.1.0",
    "devextreme-cli": "^1.16.0",
    "devextreme-themebuilder": "^25.2.8",
    "eslint": "^10.7.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-prettier": "^5.5.6",
    "glob": "^13.0.6",
    "jasmine-core": "^4.6.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.1.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "mime-types": "^2.1.35",
    "prettier": "^3.9.5",
    "ts-node": "~10.9.2",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.64.0"
  },
  "browser": {
    "crypto": false
  }
}
